import { Component, OnInit, Input } from '@angular/core';
import { ICarePlan, IAuditEvent } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-careplan-details-changes',
  templateUrl: './careplan-details-changes.component.html',
  styleUrls: ['./careplan-details-changes.component.scss'],
})
export class CareplanDetailsChangesComponent extends AbstractDetailsComponent<ICarePlan> implements OnInit {
  @Input() audit: IAuditEvent[];

  goalAuditEvents: IAuditEvent[] = [];
  definitionEvents: IAuditEvent[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
   this.setEvents();
  }

  setEvents() {
    if (this.audit && this.audit[0]) {
      this.audit.map(audi => {
        if (audi.type.display === 'goal') {
          this.goalAuditEvents.push(audi);
        } else if (audi.type.display === 'atomic' || audi.type.display === 'aggregated') {
          this.definitionEvents.push(audi);
        }
      });
    }
  }
}
